import { ITag } from '../../models/ITag';
import { isCiCdTag } from './isCiCdTag';
import { isLastTag } from './isLastTag';
import nextEntityNameGenerator from './nextEntityNameGenerator';
import * as _ from 'lodash';
import { IProject } from '../../models/IProject';

export function getNextTagName(project: IProject) {
    let tagName = '';

    const previousVersions = project.tags.filter((tag) => {
        return !isLastTag(tag) && !isCiCdTag(tag);
    });

    if (previousVersions.length > 0) {
        for (var i = 0; i < previousVersions.length; i++) {
            previousVersions[i].createTs = +previousVersions[i].createTs;
        }

        const tag = _.sortBy(previousVersions, 'createTs').reverse()[0] as ITag;
        tagName = nextEntityNameGenerator(tag.message);
    }
    return tagName;
}